/// <amd-module name="Analytics/Shared/Common/AnalyticsExtensionValidator" />
import * as Resources from "Analytics/Shared/Common/Resources";
import { IAnalyticsExtensionStateService } from "Analytics/Shared/ExtensionService/AnalyticsExtensionService";
import { AnalyticsUnavailableMessage } from "Analytics/Shared/Visuals/Common/Components/AnalyticsUnavailableMessage";
import * as React from "react";
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { routeUrl } from "VSS/Platform/Location";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

interface IAnalyticsExtensionState {
    isAnalyticsEnabled: boolean | null;
}

export interface IAnalyticsExtensionValidatorProps extends IVssComponentProperties {
    onAnalyticsEnabled?: () => void;
}

export class AnalyticsExtensionValidator extends VssComponent<IAnalyticsExtensionValidatorProps, IAnalyticsExtensionState> {
    private _analyticsExtensionStateService: IAnalyticsExtensionStateService;

    constructor(props: IVssComponentProperties, context: IVssComponentContext) {
        super(props, context);
        this._analyticsExtensionStateService = context.pageContext.getService<IAnalyticsExtensionStateService>("IAnalyticsExtensionStateService");
        this.state = { isAnalyticsEnabled: null };
    }

    public render(): JSX.Element {
        let bodyContent = <Spinner className="analytics-card-spinner flex-grow flex-column" size={SpinnerSize.large} />;
        if (this.state && this.state.isAnalyticsEnabled != null) {
            if (!this.state.isAnalyticsEnabled) {
                const imageName = "axextension-not-installed.svg";
                const url: string = routeUrl(this.context.pageContext, "ms.vss-analytics.analytics-management-route");
                bodyContent = (
                    <AnalyticsUnavailableMessage
                        imageName={imageName}
                        message={Resources.AnalyticsNotEnabledMessage}
                        suggestion={Resources.AnalyticsNotEnabledSuggestion}
                        buttonText={Resources.AnalyticsSettings}
                        buttonUrl={url}
                        ariaDescription={Resources.AnalyticsNotEnabledAriaDescription}
                    />
                );
            } else {
                bodyContent = <>{this.props.children}</>;
            }
        }

        return bodyContent;
    }

    public async componentDidMount() {
        super.componentDidMount();
        if (this.state.isAnalyticsEnabled == null) {
            const isAnalyticsEnabled = await this._analyticsExtensionStateService.isAnalyticsEnabled();
            if (this.props.onAnalyticsEnabled && isAnalyticsEnabled) {
                this.props.onAnalyticsEnabled();
            }

            this.setState({ isAnalyticsEnabled: isAnalyticsEnabled });
        }
    }
}
